import { createTheme } from '@mui/material/styles'
import { esES } from '@mui/x-data-grid'

const theme = createTheme(
  {
    typography: {
      fontFamily: ['system-ui', 'Open Sans'].join(','),
    },
    status: {
      danger: '#e53e3e',
    },
    palette: {
      primary: {
        main: '#0095ff',
        darker: '#053e85',
      },
      secondary: {
        main: '#00c0ff',
      },
      neutral: {
        main: '#0095ff',
        contrastText: '#fff',
      },
    },
  },
  esES,
)

export default theme
